import {
    Input,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    Text,
    Switch,
    FormControl,
    FormLabel,
    Badge,
    Select
} from '@chakra-ui/react';
import DatePicker from '../ui/DatePicker';
import { useDispatch, useSelector } from 'react-redux';
import saveForm from '../../redux/actions/bankForms';
import { AppDispatch } from '../../redux/storage';
import { BankCodes } from '../../utils/const';

const BanescoPaymentForm = () => {

    const dispatch = useDispatch<AppDispatch>();
    const paymentResponse = useSelector((states: any) => states.verifyPayment)

    const { reference, amount, date, phone, mobilePayment, issuingBank, accountId } = useSelector((state: any) => state.paymentForm);


    const handleChange = (event: { target: HTMLInputElement | HTMLSelectElement }) => {

        const { name, type } = event.target

        const value = type === "checkbox" ? (event.target as HTMLInputElement).checked : event.target.value;

        dispatch(saveForm(name, value))
    }

    const handleDatePicker = (e: any) => {

        dispatch(saveForm('date', e))
    }

    const handleAmount = (e: any) => {
        dispatch(saveForm('amount', e))
    }

    return (
        <>
            <FormControl display='flex' alignItems='center'>
                <FormLabel htmlFor='pago-movil' mb='0'>
                    Verificar Pago móvil
                </FormLabel>
                <Switch id='pago-movil' name="mobilePayment" isChecked={mobilePayment} onChange={handleChange} />
            </FormControl>

            <Text mb='8px' mt={2}>Banco emisor</Text>
            <Select variant='filled' name="issuingBank" onChange={handleChange} value={issuingBank}>
                <option value='' key={0}>-- Seleccionar --</option>
                {
                    paymentResponse.fetchInitialData.bank.map((banks: any) => <option value={banks.code} key={banks.code}>{banks.name}</option>)
                }
            </Select>

            <Text mb='8px' mt={2}>Referencia</Text>
            <Input placeholder='Referencia' name="reference" value={reference} onChange={handleChange} />
            {
                (issuingBank === BankCodes.BANESCO && !mobilePayment) && <Badge variant="solid">Debe tomar los (12) dígitos de referencia</Badge>
            }
            {
                (mobilePayment || (!mobilePayment && issuingBank !== BankCodes.BANESCO)) &&
                <Badge variant="solid">
                    Solo debe tomar en cuenta todos últimos (6) números
                </Badge>
            }

            {
                mobilePayment &&
                <>
                    <Text mb='8px' mt={2}>Teléfono</Text>
                    <Input placeholder='Telefono' name="phone" value={phone} onChange={handleChange} />
                </>
            }
            <Text mb='8px' mt={2}>Monto pagado</Text>
            <NumberInput name="amount" precision={2} value={amount} onChange={handleAmount}>
                <NumberInputField />
                <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                </NumberInputStepper>
            </NumberInput>
            <DatePicker
                onChange={handleDatePicker}
                selectedDate={date}
                text="Fecha del Pago"
                name="datepicker"
            />
        </>
    );
}


export default BanescoPaymentForm;
